import { auth } from 'firebase';
import Vue from 'vue';
import Router from 'vue-router';

import SignIn from '@/views/SignIn';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'SignIn',
      component: SignIn,
    },
    {
      path: '/playground',
      name: 'App',
      component: () => import('./views/App'),
    },
  ],
});

router.beforeEach((to, from, next) => {
  let currentUser = auth().currentUser;

  if (!currentUser) {
    setTimeout(() => {
      currentUser = auth().currentUser;
      if (currentUser) {
        next('/playground');
      } else {
        next();
      }
    }, 800);
  } else next();
});

export default router;
